import ItemListContainer from "../../components/ItemListContainer/ItemListContainer";

export default function Products() {
  return (
    <div>
      <h1>Product List</h1>
      <ItemListContainer />
    </div>
  );
}